import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles, Switch, Dialog, Slide } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import { images } from "../utils/images";

// Actions
import { requestSignOut, getAccount } from "../actions/index";

// Icons
import { Menu, Close, ChevronRight } from "@material-ui/icons";

// Components
import AccountType from "../components/SettingsPage/AccountType";
import DocumentCentre from "../components/SettingsPage/DocumentCentre";
import Profile from "../components/SettingsPage/Profile";
import Security from "../components/SettingsPage/Security";
import Api from "../components/SettingsPage/Api";

const urlSolo = (
  process.env.NODE_ENV === "production" ? window.SOLO.env : process.env
).REACT_APP_DASHBOARD;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

function SettingsContainer(props) {
  const { classes, t, continueVerification, account } = props;
  const [activeTab, setActiveTab] = useState("accType");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isSigningOut, setSigningOut] = useState(false);
  const [loading, setLoading] = useState(true);

  const logoSOLO = images.logos.sologenicWhiteLogo;

  useEffect(() => {
    props.getAccount();

    document.body.style.background = "#262626";
  }, []);

  useEffect(() => {
    if (account.account === null && account.updated) {
      // window.location.href = "/login";
      props.history.push("/id/login");
    }

    if (account.account && account.account.level === 0) {
      props.history.push("/id/verification");
    }
    setLoading(false);
  }, [account]);

  useEffect(() => {
    if (continueVerification) {
      return props.history.push("/id/upgrade");
    }

    if (props.history.location.state) {
      if (props.history.location.state.to_docs) {
        setTab("docs");
      }
    }

    // props.history.push("/settings");
  }, [continueVerification]);

  const setTab = (tab) => {
    if (account.account === null) {
      return;
    }

    setActiveTab(tab);
  };

  const signOut = () => {
    props.requestSignOut();
  };
  const goToDashboard = () => {
    window.location.href = urlSolo;
  };

  if (loading) {
    return <span />;
  }

  return (
    <div className={`contentContainer ${classes.settingsContainer}`}>
      <div className={classes.soloLogo}>
        <img
          style={{ cursor: "pointer" }}
          src={images.logos.sologenicWhiteLogo}
          onClick={() => (window.location.href = urlSolo)}
        />
      </div>
      <div className={classes.mobileMenu}>
        <Menu onClick={() => setMobileMenuOpen(true)} />
        <div className="activeButton" onClick={() => setMobileMenuOpen(true)}>
          <p>{t(`${activeTab}`)}</p>
        </div>
        {mobileMenuOpen ? (
          <Dialog
            fullScreen
            open
            TransitionComponent={Transition}
            classes={{ root: classes.mmRoot, paper: classes.mmPaper }}
          >
            <div className="mobMenuHeader">
              <img src={logoSOLO} />
              <Close onClick={() => setMobileMenuOpen(false)} />
            </div>
            <div className="dashboardBtn">
              <button onClick={() => goToDashboard()}>
                {t("goToDashboard")}
              </button>
            </div>
            <div className="mobSettingsBtns">
              <p
                onClick={() => {
                  setMobileMenuOpen(false);
                  setTab("accType");
                }}
              >
                {t("accType")}
                <ChevronRight />
              </p>
              {/* <p
                onClick={() => {
                  setMobileMenuOpen(false);
                  setTab("docs");
                }}
              >
                {t("documentCentre")}
                <ChevronRight />
              </p> */}

              <p
                onClick={() => {
                  setMobileMenuOpen(false);
                  setTab("profile");
                }}
              >
                {t("profile")}
                <ChevronRight />
              </p>
              <p
                onClick={() => {
                  setMobileMenuOpen(false);
                  setTab("security");
                }}
              >
                {t("security")}
                <ChevronRight />
              </p>
              <p
                onClick={() => {
                  setMobileMenuOpen(false);
                  setTab("api");
                }}
              >
                {t("api")}
                <ChevronRight />
              </p>
            </div>
            <div className="signOut">
              <button onClick={() => setSigningOut(true)}>
                {t("_signOut")}
              </button>
            </div>
          </Dialog>
        ) : (
          ""
        )}
        {/* <div className="signOut">
          <button onClick={() => setSigningOut(true)}>{t("_signOut")}</button>
        </div> */}
      </div>
      <div className={`settingsHeader ${classes.desktopMenu}`}>
        <div className="settingsBtns">
          <p
            className={activeTab === "accType" ? "activeTab" : ""}
            onClick={() => setTab("accType")}
          >
            {t("accType")}
          </p>
          {/* <p
              className={activeTab === "docs" ? "activeTab" : ""}
              onClick={() => setTab("docs")}
            >
              {t("documentCentre")}
            </p> */}

          <p
            className={activeTab === "profile" ? "activeTab" : ""}
            onClick={() => setTab("profile")}
          >
            {t("profile")}
          </p>
          <p
            className={activeTab === "security" ? "activeTab" : ""}
            onClick={() => setTab("security")}
          >
            {t("security")}
          </p>
          <p
            className={activeTab === "api" ? "activeTab" : ""}
            onClick={() => setTab("api")}
          >
            {t("api")}
          </p>
        </div>
        <div className="actionBtns">
          <div className="dashboardBtn desktopBtn">
            <button onClick={() => goToDashboard()}>{t("goToTrading")}</button>
          </div>
          <div className="signOut">
            <button onClick={() => setSigningOut(true)}>{t("_signOut")}</button>
          </div>
        </div>
      </div>
      <div className="settingsBody">
        {activeTab === "accType" ? <AccountType router={props.history} /> : ""}
        {activeTab === "docs" ? <DocumentCentre changeTab={setTab} /> : ""}
        {activeTab === "profile" ? <Profile changeTab={setTab} /> : ""}
        {activeTab === "security" ? <Security /> : ""}
        {activeTab === "api" ? <Api changeTab={setTab} /> : ""}
      </div>
      <Dialog
        open={isSigningOut}
        classes={{ paper: classes.modal }}
        scroll="body"
      >
        <div className="modalHeader">
          <p>{t("_signingOut")}</p>
        </div>
        <div className="modalBody">
          <p>{t("_sureToSignOut")}</p>
          <div className="btns">
            <button className="cancelBtn" onClick={() => setSigningOut(false)}>
              {t("cancel")}
            </button>
            <button className="confirmBtn" onClick={() => signOut()}>
              {t("_signOut")}
            </button>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    continueVerification: state.continueVerification,
    account: state.account,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      requestSignOut,
      getAccount,
    },
    dispatch
  );
}

const styles = (theme) => ({
  soloLogo: {
    marginBottom: 80,
    width: "100%",
    height: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    position: "relative",
    "& img": {
      width: 180,
      height: "auto",
    },
  },
  settingsContainer: {
    color: theme.colors.text.primary,
    width: "100%",
    paddingTop: 64,

    "& .settingsHeader": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 24,

      width: "95%",
      marginLeft: "auto",
      marginRight: "auto",
      maxWidth: 1100,

      "& .settingsBtns": {
        display: "flex",

        "& p": {
          color: theme.colors.misc._blue,
          cursor: "pointer",
          transition: ".3s",
          // padding: "6px 0px 2px",
          // textTransform: "uppercase",
          marginRight: 4,
          fontSize: 16,
          marginRight: 12,
          "&:hover": {
            // background: theme.colors.background.active,
            // borderBottom: `2px solid ${theme.colors.text.textOnRed}`,
            // borderRadius: 25,
          },
          "&.activeTab": {
            // background: theme.colors.background.active,
            // borderRadius: 25,
            // borderBottom: `2px solid ${theme.colors.text.textOnRed}`,
            color: theme.colors.misc._blue,
            fontWeight: 700,
          },
        },
      },

      "& .signOut": {
        "& button": {
          ...theme.defaults.roundBtn,
          background: "none",
          borderColor: theme.colors.text.primary,
          color: theme.colors.text.primary,
          boxShadow: "none",
          width: 180,
        },
      },
      [theme.breakpoints.down(900)]: {
        flexDirection: "column",
        alignItems: "center",
      },
      [theme.breakpoints.down(650)]: {
        flexDirection: "column",
        "& .settingsBtns": {
          "& p": {
            fontSize: `12px !important`,
            textAlign: "center",
          },
        },
      },
    },
    "& .settingsBody": {
      marginBottom: 36,
      width: "95%",
      marginLeft: "auto",
      marginRight: "auto",
      maxWidth: 1100,
      display: "flex",
      justifyContent: "center",
    },
    "& .actionBtns": {
      display: "flex",
      [theme.breakpoints.down(900)]: {
        // marginLeft: 0,
        // marginRight: "auto",
        marginTop: 16,
      },
    },
    "& .dashboardBtn": {
      display: "flex",
      marginRight: "8px",

      "& button": {
        ...theme.defaults.roundBtn,
        background: theme.colors.background.active,
        width: 180,
        boxShadow: "none",
      },
    },
  },
  desktopMenu: {
    [theme.breakpoints.down(500)]: {
      display: "none !important",
    },
  },
  mobileMenu: {
    position: "relative",
    [theme.breakpoints.up(499)]: {
      display: "none !important",
    },

    "& .activeButton": {
      width: "95%",
      margin: "0 auto 8px",
      border: `1px solid transparent`,
      borderRadius: 4,
      padding: 8,
      background: theme.colors.background.fore,
    },
    "& svg": {
      position: "absolute",
      top: 0,
      right: 16,
      transform: "translateY(30%)",
    },
    "& .dashboardBtn": {
      width: "95%",
      margin: "8px auto",
      display: "flex",
      justifyContent: "center",
      "& a": {
        ...theme.defaults.roundBtn,
        textDecoration: "none",
        borderBottom: `1px solid ${theme.colors.text.primary}`,
        paddingBottom: 2,
        borderRadius: 0,
        height: "auto",
        minHeight: "none",
      },
    },
    "& .mobSettingsBtns": {
      width: "95%",
      margin: "0 auto 16px",
      border: `1px solid ${theme.colors.background.active}`,
      borderRadius: 4,
      padding: "0 8px",
      "& p": {
        margin: "8px 0",
      },
    },
  },
  modal: {
    background: theme.colors.background.fore,
    borderRadius: 2,
    width: "95%",
    maxWidth: 500,
    margin: 0,
    "& .modalHeader": {
      background: theme.colors.background.lightFore,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: theme.colors.text.primary,
      fontWeight: 600,
      height: 75,
      fontSize: 18,
      boxShadow: `0 2px 4px #D6D6D6`,
    },
    "& .modalBody": {
      padding: "40px 24px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      color: theme.colors.text.primary,

      "& .btns": {
        marginTop: 40,
        "& button": {
          ...theme.defaults.roundBtn,
          background: theme.colors.buttons.green,
          "&:first-of-type": {
            marginRight: 8,
            background: "none",
            borderColor: theme.colors.text.primary,
            color: theme.colors.text.primary,
          },
        },
        [theme.breakpoints.down(360)]: {
          display: "flex",
          flexDirection: "column-reverse",
          alignItems: "center",
          "& button": {
            marginBottom: 8,
            "&:first-of-type": {
              marginRight: "0 !important",
            },
          },
        },
      },
    },
  },
  mmPaper: {
    background: theme.colors.background.main,
    color: theme.colors.text.primary,
    padding: 16,
    "& .mobMenuHeader": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      "& img": {
        width: "50%",
      },
    },
    "& .dashboardBtn": {
      marginTop: 32,
      marginBottom: 32,

      "& button": {
        ...theme.defaults.roundBtn,
        maxWidth: "none",
        background: theme.colors.background.mobDashBtn,
        width: "100%",
        color: theme.colors.text.primary,
      },
    },
    "& .mobSettingsBtns": {
      "& p": {
        height: 60,
        display: "flex",
        alignItems: "center",
        borderBottom: `.5px solid ${theme.colors.background.inactive}`,
        // fontFamily: "Titillium Web",
        color: theme.colors.text.textOnRed,
        "& svg": {
          marginLeft: "auto",
        },

        "&:last-of-type": {
          borderBottom: "none",
        },
      },
    },
    "& .signOut": {
      height: 50,
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      position: "absolute",
      width: "100%",
      bottom: 0,
      left: 0,
      background: theme.colors.background.fore,
      paddingRight: 16,
      boxShadow: "none",
      "& button": {
        background: "none",
        border: "none",
        color: theme.colors.misc.signOut,

        fontWeight: 600,
        // fontFamily: "Titillium Web",
        height: "100%",
      },
    },
  },
});

export default withStyles(styles)(
  withTranslation()(
    connect(mapStateToProps, mapDispatchToProps)(SettingsContainer)
  )
);
